// NonAdminLeftSidebar.jsx - Using roleStorage utilities
import React, { useLayoutEffect, useMemo, useRef, useState } from "react";
import { useLocation, Link } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import { useSelector } from "react-redux";
import SidebarButton from "@components/Sidebar/Others/SidebarButton";
import { CircularProgress, Divider } from "@mui/material";
import { TaleLoadingFallback } from "@components/TaleLoadingFallback";
import { getNonAdminLeftSideBar } from "@/utils/featureFlipDependepent";
import { FF } from "@/utils/featureFlip";
import authService from "@services/auth";
import {getUserType, isCompanyUser, isNormalUser} from "@/utils/roleStorage";


export const NonAdminLeftSidebar = ({ sidebarVisible }) => {
    const location = useLocation();
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const { logout: auth0Logout } = useAuth0();

    // Get user from Redux store
    const { user } = useSelector((state) => state.auth);
    console.log(user)
    // Get role from storage utilities
    const role = useMemo(() => getUserType(), []);
    console.log(role)
    // Check user type using storage utilities
    const isnormalUser = useMemo(() => isNormalUser(), []);
    const iscompanyUser = useMemo(() => isCompanyUser(), []);

    const handleLogout = async () => {
        const authType = localStorage.getItem("auth_type");

        if (authType === "local") {
            // Local auth logout
            authService.logout();
        } else {
            // Auth0 logout
            // Clear local storage first
            localStorage.removeItem("access_token");
            localStorage.removeItem("refresh_token");
            localStorage.removeItem("auth_type");
            localStorage.removeItem("user");

            await auth0Logout({
                logoutParams: {
                    returnTo: `${process.env.REACT_APP_WEBSITE}/login`,
                },
            });
        }
    };

    const sidebarButtons = useMemo(() => getNonAdminLeftSideBar(role), [role]);

    const activeButtonsMapping = useMemo(
        () => ({
            Dashboard: [""],
            Surveys: ["surveys", "survey"],
            "Focus group": ["focus-groups", "focus-group"],
            Awards: ["awards"],
            ...(isnormalUser || FF.USE_ASSISTANCE
                ? { Assistance: ["assistance"] }
                : {}),
            Interviews: ["interviews"],
            Factures: ["factures"],
            Reports: ["reports"],
            ...(FF.USE_EXCLUSIVITY ? { "Tale exclusivity": ["exclusivity"] } : {}),
        }),
        [isnormalUser]
    );

    const activeButton = useMemo(() => {
        const path = location.pathname.split("/").at(1);
        const keys = Object.keys(activeButtonsMapping);
        return keys.find((k) => activeButtonsMapping[k].some((l) => l === path));
    }, [activeButtonsMapping, location.pathname]);

    const ref = useRef(null);
    const [itemWidth, setitemWidth] = useState(0);

    useLayoutEffect(() => {
        if (ref.current) setitemWidth(ref.current?.getBoundingClientRect().width);
    }, [sidebarVisible]);

    return (
        <div
            className={`z-50 transition-all`}
            style={{
                minWidth: sidebarVisible ? itemWidth : 60,
            }}
        >
            <div
                ref={ref}
                className="bg-white rounded-2xl min-h-[calc(100vh-100px)] flex flex-col justify-between fixed z-50"
            >
                <div className="grow justify-between flex flex-col">
                    <div
                        style={{
                            borderRadius: 10,
                            flexDirection: "column",
                            justifyContent: "flex-start",
                            alignItems: "flex-start",
                            gap: 1,
                            display: "inline-flex",
                        }}
                        className="p-2"
                    >
                        {!role ? (
                            <TaleLoadingFallback className="pt-20">
                                <CircularProgress />
                            </TaleLoadingFallback>
                        ) : (
                            sidebarButtons.map((e) => (
                                <Link key={e.label} to={e.url} className="w-full">
                                    <SidebarButton
                                        role={role}
                                        label={e.label}
                                        icon={e.icon}
                                        active={activeButton === e.label}
                                        expand={sidebarVisible}
                                    />
                                </Link>
                            ))
                        )}
                    </div>

                    <div
                        style={{
                            borderRadius: 10,
                            flexDirection: "column",
                            justifyContent: "flex-start",
                            alignItems: "flex-start",
                            gap: 1,
                            display: "inline-flex",
                        }}
                        className="p-2"
                    >
                        {[
                            ...(iscompanyUser && FF.USE_EXCLUSIVITY
                                ? [
                                    {
                                        label: "Tale exclusivity",
                                        icon: "/assets/sidebar/exclusivity.svg",
                                        url: "/exclusivity",
                                    },
                                ]
                                : []),
                            ...(isnormalUser || FF.USE_ASSISTANCE
                                ? [
                                    {
                                        label: "Assistance",
                                        icon: "/assets/sidebar/assistance.svg",
                                        url: "/assistance",
                                    },
                                ]
                                : []),
                            {
                                label: "Logout",
                                icon: "/assets/sidebar/logout.svg",
                                url: null,
                            },
                        ].map((e, i) => {
                            const button = (
                                <SidebarButton
                                    key={i}
                                    role={role}
                                    label={e.label}
                                    icon={e.icon}
                                    active={activeButton === e.label}
                                    onClick={() =>
                                        e.label === "Logout" ? handleLogout() : undefined
                                    }
                                    expand={sidebarVisible}
                                />
                            );
                            return e.label === "Logout" ? (
                                button
                            ) : (
                                <Link key={e.label} to={e.url} className="w-full">
                                    {button}
                                </Link>
                            );
                        })}
                    </div>
                </div>
                <div className="flex flex-col gap-1">
                    <Divider />
                    <div
                        className={`p-2 flex ${
                            sidebarVisible ? "gap-1" : "flex-col"
                        } justify-center items-center`}
                        style={{
                            color: "#666666",
                            fontSize: 12,
                            fontFamily: "revert",
                            fontWeight: "400",
                        }}
                    >
                        {!sidebarVisible ? null : <span>©{currentYear} </span>}
                        <span>Tale. {!sidebarVisible ? null : "All rights reserved."}</span>
                    </div>
                </div>
            </div>
        </div>
    );
};
